<select2
    #select2Component
    class="form-control select2-form-control {{disabled?'bg-grey':''}} {{showValidation && (!disabled && field && field.iifIsValid('border-success','border-danger'))}}"
    [data]="formCategorySelectData"
    [options]="formCategorySelectOptions"
    (valueChanged)="valueChanged($event.data)"
    [value]="defaultValue"
    [disabled]="disabled"
  ></select2>